import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

export const ClientInvoiceContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",

  "& > .MuiGrid-root, & > .MuiFormControl-root": {
    margin: "0 0 10px 0",
  },
});

export const VatContainer = styled(Grid)({
  "& > .MuiAutocomplete-root": {
    width: "800px",
  },
});
